import { render, staticRenderFns } from "./QuickEMailService.vue?vue&type=template&id=79ea4bee&"
import script from "./QuickEMailService.vue?vue&type=script&lang=js&"
export * from "./QuickEMailService.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/formats.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports